import { API_URL } from '../../utils/config';
import React from 'react';
import axios from 'axios';
import { ButtonGroup, Button, Glyphicon } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import AddListwaModal from './AddListwa';
import UpdateListwaModal from './UpdateListwa';
import {isLoggedIn, ifMagazyn, ifAdmin } from '../../utils/AuthService';

// Grupowy opis kawalkow: "300,300,300,100" -> "3m × 3 + 1m"
// Grupuje globalnie wszystkie identyczne kawalki (niezaleznie od kolejnosci).
// Porzadek wyswietlania: kolejnosc pierwszego wystapienia danej dlugosci.
function formatKawalki(str) {
	if (typeof str !== 'string' || str.trim() === '') return '';
	var parts = str.split(',').map(function(s) { return parseFloat(String(s).trim()); }).filter(function(n) { return !isNaN(n) && n > 0; });
	if (parts.length === 0) return '';
	var map = {};
	var order = [];
	parts.forEach(function(dl) {
		var key = String(dl);
		if (map[key] === undefined) { map[key] = 0; order.push(dl); }
		map[key] += 1;
	});
	return order.map(function(dl) {
		var ile = map[String(dl)];
		var m = (dl / 100);
		return ile > 1 ? (m + 'm × ' + ile) : (m + 'm');
	}).join(' + ');
}

var StanListwy = React.createClass({

	getInitialState: function() {
		return {
			data: null,
			selectedListwaId: null,
			showAddModal: false,
			showUpdateModal: false
		}
    },

	componentDidMount: function() {
		this.refreshTable();
	},

	render: function() {

		var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};

		if(!isLoggedIn()){
			return (<div></div>);
		};

		return (
			<div>
				<ButtonGroup className="m-10">
					<Button bsStyle="primary" onClick={this.openAddModal}><Glyphicon glyph="plus" />Dodaj listwę</Button>
					<Button bsStyle="warning" disabled={this.state.selectedListwaId === null} onClick={this.openUpdateModal}><Glyphicon glyph="refresh" />Aktualizuj</Button>
					<Button bsStyle="danger" disabled={this.state.selectedListwaId === null} onClick={this.onDeleteBtnClicked}><Glyphicon glyph="trash" />Usuń</Button>
				</ButtonGroup>

				<BootstrapTable data={this.state.data}
					striped={true}
					hover={true}
					pagination={true}
					search={true}
					selectRow={selectRowProp}>
						<TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
						<TableHeaderColumn dataField="numerListwy" dataSort={true}>Numer listwy</TableHeaderColumn>
						<TableHeaderColumn dataField="kawalki" dataFormat={this.formatKawalkiCell}>Kawałki</TableHeaderColumn>
						<TableHeaderColumn dataField="iloscCm" dataSort={true} dataFormat={this.formatMetry}>Łączna długość [m]</TableHeaderColumn>
						<TableHeaderColumn dataField="ilot" dataSort={true}>Ilot</TableHeaderColumn>
			 </BootstrapTable>

				<AddListwaModal parent={this} ref="addListwa" />
				<UpdateListwaModal parent={this} ref="updateListwa"/>

			</div>
		);
	},

	formatMetry: function(cell) {
		var n = parseFloat(cell);
		if (isNaN(n)) return '';
		return (n / 100).toFixed(2).replace(/\.?0+$/, '');
	},

	formatKawalkiCell: function(cell) {
		return formatKawalki(cell);
	},

	onRowSelect: function(row, isSelected) {
		if(isSelected) {
			this.setState({ selectedListwaId: row.id });
		}else {
			this.setState({ selectedListwaId: null });
		}
	},

	closeAddModal: function() {
		this.setState({ showAddModal: false });
		this.refs.addListwa.clearAddObject();
	},

	openAddModal: function() {
		this.refs.addListwa.clearAddObject();
		this.setState({ showAddModal: true });
	},

	closeUpdateModal: function() {
		this.setState({showUpdateModal: false});
		this.refs.updateListwa.clearUpdateObject();
	},

	openUpdateModal: function() {
		this.refs.updateListwa.fillUpdateObject();
		this.setState({showUpdateModal: true});
	},

	onDeleteBtnClicked: function() {

		axios.delete(API_URL + '/stanListwy/' + this.state.selectedListwaId)
			.then(function (response) {
				this.refreshTable();
			}.bind(this))
			.catch(function (error) {
				console.log(error);
			});
	},

	getListwaById: function(id) {
		for(var i in this.state.data) {
			if(this.state.data[i].id === id) {
				return this.state.data[i];
			}
		}
		return '';
	},

	refreshTable: function() {
		axios.get(API_URL + '/stanListwy')
		.then(function (stanListwy) {
			this.setState({data: stanListwy.data});
		}.bind(this));
	}
});

export default StanListwy;



// WEBPACK FOOTER //
// ./src/components/StanListwy/StanListwy.js